<template>
  <div class="login-frame">
    <div class="login-frame-title">登录</div>
    <Form class="login" ref="loginForm" :model="login" :rules="{}" :validOnChange="true">
      <FormItem :showLabel="false" required prop="mobile" label="账号">
        <div class=" h-input-prefix">
          <div class="h-input-prefix-icon">
            <i class="fa fa-user"></i>
          </div>
          <Input v-model.trim="login.mobile" type="text" placeholder="请输入账号" class="h-42px"/>
        </div>
      </FormItem>
      <FormItem :showLabel="false" required prop="password" label="密码" class="my-16px">
        <div class=" h-input-prefix">
          <div class="h-input-prefix-icon">
            <i class="fa fa-lock"></i>
          </div>
          <Input v-model.trim="login.password" placeholder="请输入密码" type="password" @keyup.enter="submit"/>
        </div>
        <div class="text-right mt-16px">
          <span @click="$emit('changeView','ForgotPassword')" class="placeholder forgot-password text-hover">
            忘记密码
          </span>
        </div>
      </FormItem>
      <FormItem :showLabel="false" class="!pb-0px">
        <Button @click="submit" :loading="loading" color="primary" block>登 录</Button>
<!--        <div class="text-center mt-32px" v-if="webConfig.register">-->
<!--          还没账号，-->
<!--          <span class="text-hover primary-color" @click="$emit('changeView','Registered')">注册账号</span>-->
<!--        </div>-->
      </FormItem>
    </Form>

    <!-- 修改密码弹窗 -->
    <Modal v-model="showChangePasswordModal" title="修改密码" :maskClosable="false" width="800">
      <Form ref="changePasswordForm" :model="changePasswordData" :rules="changePasswordRules" :labelWidth="100">
        <FormItem label="原密码" prop="original">
          <Input type="password" v-model="changePasswordData.original"/>
        </FormItem>
        <FormItem label="新密码" prop="newPassword">
          <Input type="password" v-model="changePasswordData.newPassword"/>
        </FormItem>
        <FormItem label="重复密码" prop="repeatPassword">
          <Input type="password" v-model="changePasswordData.repeatPassword"/>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center; display: flex; justify-content: center; gap: 10px;">
        <Button @click="cancelChangePassword">取消</Button>
        <Button @click="changePassword" color="primary" :loading="changePasswordLoading">确认修改</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import common from "@api/common";
import {confirm, message} from "heyui.ext";

export default {
  name: 'LoginForm',
  data() {
    return {
      login: {
        mobile: localStorage.getItem("login_mobile"),
        password: "",
      },
      loading: false,
      showChangePasswordModal: false,
      changePasswordLoading: false,
      changePasswordData: {
        original: "",
        newPassword: "",
        repeatPassword: "",
      },
      changePasswordRules: {
        required: ["original", "newPassword", "repeatPassword"],
        combineRules: [{
          refs: ['newPassword', 'repeatPassword'],
          valid: {
            valid: 'equal',
            message: '两次输入的密码不一致'
          }
        }]
      }
    }
  },
  computed: {
    ...mapState(['webConfig'])
  },
  methods: {
    submit() {
      let validResult = this.$refs.loginForm.valid();
      if (validResult.result) {
        this.loading = true
        common.login(this.login).then(() => {
          localStorage.setItem("login_mobile", this.login.mobile);

          if (this.checkPasswordIsLastSixDigits()) {
            this.showPasswordChangeReminder();
          } else {
            window.location.replace('/');
          }
        }).catch(() => {
          this.loading = false
        });
      }
    },

    // 检查密码是否为账号后六位
    checkPasswordIsLastSixDigits() {
      const mobile = this.login.mobile;
      const password = this.login.password;

      if (!mobile || !password || mobile.length < 6) {
        return false;
      }

      const lastSixDigits = mobile.slice(-6);
      return password === lastSixDigits;
    },

    // 修改密码提醒
    showPasswordChangeReminder() {
      confirm({
        title: '安全提醒',
        content: '检测到您使用的是默认密码，为了账户安全，建议您立即修改密码。',
        okText: '立即修改',
        cancelText: '稍后修改',
        onConfirm: () => {
          this.showChangePasswordModal = true;
        },
        onCancel: () => {
          window.location.replace('/');
        }
      });
    },

    cancelChangePassword() {
      this.showChangePasswordModal = false;
      this.changePasswordLoading = false;
      this.loading = false;
      this.changePasswordData = {
        original: "",
        newPassword: "",
        repeatPassword: "",
      };
    },

    // 修改密码
    changePassword() {
      let validResult = this.$refs.changePasswordForm.valid();
      if (validResult.result) {
        this.changePasswordLoading = true;
        common.updatePwd(this.changePasswordData).then(() => {
          message('更新密码成功');
          this.changePasswordLoading = false;
          this.showChangePasswordModal = false;
          window.location.replace('/');
        }).catch(() => {
          this.changePasswordLoading = false;
        });
      }
    }
  }
}
</script>
<style lang="less">
.login-frame {
  width: 400px;

  &-title {
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 32px;
  }
}

:deep(.h-modal .h-modal-content) {
  width: 800px !important;
}

:deep(.h-modal .h-form-item .h-form-item-label) {
  white-space: nowrap !important;
  min-width: 100px !important;
  width: 100px !important;
  flex-shrink: 0 !important;
}
</style>
